import { render, staticRenderFns } from "./DeleteUserAccountButton.vue?vue&type=template&id=64dea830&"
import script from "./DeleteUserAccountButton.vue?vue&type=script&lang=js&"
export * from "./DeleteUserAccountButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports